import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "big-icon top-left fill-block" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "previews fill-block" }
const _hoisted_4 = { class: "preview-container fill-block" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';

import * as utils from '@services/utils/common';

import type { IFolder, IPhoto } from '@typings';

import FolderIcon from 'vue-material-design-icons/Folder.vue';
import XImg from '@components/frame/XImg.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'Folder',
},
  __name: 'Folder',
  props: {
    data: {}
  },
  setup(__props: any) {



const props = __props;

const route = useRoute();

/** Open folder */
const target = computed(() => {
  let path: string[] | string = route.params.path || [];
  if (typeof path === 'string') {
    path = path.split('/');
  }

  path = [...path, props.data.name]; // intentional copy
  return {
    name: route.name,
    params: { ...route.params, path },
    query: route.query,
  };
});

const previews = computed((): IPhoto[] => {
  const previews = props.data.previews;
  if (!previews?.length) {
    return [];
  }

  if (previews.length > 0 && previews.length < 4) {
    return [previews[0]];
  } else {
    return previews.slice(0, 4);
  }
});

const sanitizedName = computed((): string => {
  return props.data.name.replaceAll(/[^a-zA-Z0-9-_]/g, '');
});

/** Get preview url */
function previewUrl(info: IPhoto) {
  return utils.getPreviewUrl({
    photo: info,
    sqsize: 256,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    draggable: "false",
    class: _normalizeClass(["folder fill-block", {
      [`folder--${sanitizedName.value}`]: true,
      'has-previews': previews.value.length > 0,
      'single-preview': previews.value.length === 1,
    }]),
    to: target.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FolderIcon, { class: "icon" }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.data.name), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previews.value, (info) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "img-outer",
              key: info.fileid
            }, [
              _createVNode(XImg, {
                class: "ximg fill-block",
                src: previewUrl(info)
              }, null, 8, ["src"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["class", "to"]))
}
}

})